@if (order(); as order) {
    <sf-card
        cardTitle="Order #{{ order.orderNumber ?? order.id }} {{
            order.customer ? 'for ' + order.customer.fullName : ''
        }}">
        <ng-container *sfCardHeader>
            <span class="fw-bold">{{ order.created | date: 'dd MMM yyyy HH:mm a' }}</span>
        </ng-container>

        <p><span class="fw-bold">Method:</span> {{ order.method }}</p>

        @if (order.orderType) {
            <p><span class="fw-bold">Type:</span> {{ order.orderType }}</p>
        }

        @if (order.address) {
            <p><span class="fw-bold">Address:</span> {{ order.address }}</p>
        }

        <table sfTable small striped [responsive]="true" hover align="middle">
            <thead sfTableColor="light">
                <tr>
                    <th>Description</th>
                    <th>Product Id</th>
                    <th>MPN</th>
                    <th>Quantity</th>
                </tr>
            </thead>
            <tbody>
                @for (item of order.items | slice: 0 : displayCount; track item.id) {
                    <tr>
                        <td>{{ item.description }}</td>
                        <td>{{ item.productId }}</td>
                        <td>{{ item.mpn }}</td>
                        <td>{{ item.quantity }}</td>
                    </tr>
                }
            </tbody>
            @if (order.items.length > 3) {
                <tfoot>
                    <tr>
                        <td colspan="4">
                            <button sfButton type="button" color="primary" size="sm" (click)="toggleShowAll()">
                                {{ displayCount === 3 ? 'Show All ' + order.items.length + ' items' : 'Show Less' }}
                            </button>
                        </td>
                    </tr>
                </tfoot>
            }
        </table>

        <ng-container *sfCardFooter>
            <div class="d-flex gap-1">
                @if (order.customerId) {
                    <button
                        sfButton
                        type="button"
                        color="primary"
                        size="sm"
                        routerLink="/customers/{{ order.customerId }}">
                        View Customer
                    </button>
                }
                @if (order.appointmentId) {
                    <button
                        sfButton
                        type="button"
                        color="primary"
                        size="sm"
                        routerLink="/appointment/{{ order.appointmentId }}">
                        View Appointment
                    </button>
                }
                @if (order.smartQuoteId) {
                    <button
                        sfButton
                        type="button"
                        color="primary"
                        size="sm"
                        routerLink="/smartquote/{{ order.smartQuoteId }}">
                        View SmartQuote
                    </button>
                }
                @if (order.wizardQuoteId) {
                    <button sfButton type="button" color="primary" size="sm" [disabled]="true">
                        View Quote Wizard
                    </button>
                }
                @if (order.surequoteQuoteWizardQuoteId) {
                    <button
                        sfButton
                        type="button"
                        color="primary"
                        size="sm"
                        (click)="viewSurequoteQuoteWizardQuote(order.surequoteQuoteWizardQuoteId)">
                        View Quote
                    </button>
                }
            </div>
        </ng-container>
    </sf-card>
}
